import { render } from "./CategoryKeywordBlock.vue?vue&type=template&id=1a874bba"
import script from "./CategoryKeywordBlock.vue?vue&type=script&lang=js"
export * from "./CategoryKeywordBlock.vue?vue&type=script&lang=js"

import "./CategoryKeywordBlock.vue?vue&type=style&index=0&id=1a874bba&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__